// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/invoices/accounts-receivables-ageing-report',
        component: () =>
            import('@/pages/[organisation]/accounting/invoices/accounts-receivables-ageing-report.vue'),
        name: 'reports.invoices.search-accounts-receivables-ageings',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.invoice.view-invoices',
        },
    },
    {
        path: '/:organisation/accounting/invoices/sales-by-services-report',
        component: () =>
            import('@/pages/[organisation]/accounting/invoices/sales-by-services-report.vue'),
        name: 'reports.invoices.search-sales-by-services',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.invoice.view-invoices',
        },
    },
    {
        path: '/:organisation/accounting/invoices/sales-by-products-report',
        component: () =>
            import('@/pages/[organisation]/accounting/invoices/sales-by-products-report.vue'),
        name: 'reports.invoices.search-sales-by-products',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.invoice.view-invoices',
        },
    },
    {
        path: '/:organisation/accounting/invoices/sales-by-customer-report',
        component: () =>
            import('@/pages/[organisation]/accounting/invoices/sales-by-customer-report.vue'),
        name: 'reports.invoices.search-sales-by-customer',

        meta: {
            loginRequired: true,
            permission: 'access.receivables.invoice.view-invoices',
        },
    },
];
